



























































import { Component, Vue } from 'vue-property-decorator'
import { MetaInfo } from 'vue-meta'
import { common } from '@/app/model/store/domain/const'
/* component */
import CommonHeader from '@/app/components/Common/Header.vue'
import Loading from '@/app/components/Common/Loading.vue'
import ErrorModal from '@/app/components/Common/ErrorModal.vue'
import CommonClass from '@/app/module/common'
import NewsBoardSearch from '@/app/components/NewsBoard/NewsBoardSearch.vue'
import NewsBoardListApi from '@/app/model/api/newsBoardListApi'
import NewsBoardBox from '@/app/components/NewsBoard/NewsBoardBox.vue'

@Component({
  components: {
    NewsBoardBox,
    NewsBoardSearch,
    CommonHeader,
    Loading,
    ErrorModal
  },
  metaInfo (this: newsBoard): MetaInfo {
    return {
      title: CommonClass.getServiceFunctionData().news_board.news_board_name + ' | ' + common.SYSTEM_NAME
    }
  }
})
export default class newsBoard extends Vue {
  private newsBoardCount: number = 0
  private newsBoardContentCount: number = 0
  private newsBoardData: any = {}

  private notDataMessage: boolean = false
  private showLoading: boolean = true

  created () {
    if (this.$store.state.newsBoardState.selectedYear === 0) {
      this.$store.state.newsBoardState.selectedYear = (new Date()).getFullYear()
    }
    this.getNewsBoardList()
  }

  private getNewsBoardList () {
    (async () => {
      const result = await NewsBoardListApi.getList(
        this.$store.state.newsBoardState.searchText,
        this.$store.state.newsBoardState.selectedYear
      )

      if (result.isOk()) {
        const payload = result.getPayload()

        if (payload.news_boards.length === 0) {
          this.newsBoardCount = 0
          this.newsBoardContentCount = 0
          this.notDataMessage = true
        } else {
          this.newsBoardData = payload.news_boards
          this.newsBoardCount = this.newsBoardData.length
          this.newsBoardContentCount = this.countNewsBoardContents(this.newsBoardData)
          this.notDataMessage = false
        }
      } else {
        const errorData = CommonClass.doErrorHandring(result.getPayload(), 'web', 'GET', 'alert')
      }
      this.showLoading = false
    })()
  }

  private changeList () {
    this.showLoading = true
    this.scrollTop()
    this.getNewsBoardList()
  }

  private scrollTop () : any {
    const newsBoardArea: any = document.getElementById('listContainer')!
    newsBoardArea.scrollTop = 0
  }

  private countNewsBoardContents (data: any) {
    let contentsCount = 0
    for (const datum of data) {
      contentsCount += datum.news_board_contents.length
    }
    return contentsCount
  }
}
